module.exports = __webpack_public_path__ + "static/media/image-upload.770c5d5a.svg";